import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import CTAButton from 'src/components/common/CTAButtonNew'
import {
  body,
  borderRadius,
  borderWidth,
  breakpoints,
  colors,
  spacing,
  typographyMixin,
} from 'src/constants/marketing-ds'
import { selectParams } from 'src/modules/reducers/params'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import styled from 'styled-components'

const CTAButtonOfferCode = ({ link, children, onClick, ...props }) => {
  const params = useSelector(selectParams)
  const paramsOffer = params?.offer

  const [offerCode, setOfferCode] = useState('')

  useEffect(() => {
    if (paramsOffer) {
      setOfferCode(paramsOffer)
    }
  }, [paramsOffer])

  const handleInputChange = (event) => {
    setOfferCode(event.target.value)
  }

  let ctaURL = link

  const handleButtonClick = (e) => {
    e.preventDefault()
    if (onClick) {
      onClick()
    }
    ctaURL = replaceUrlParam(ctaURL, 'offer', offerCode)
    window.location.href = ctaURL
  }

  return (
    <StyledCTAButtonOfferCodeContainer className="CTAButtonOfferCode">
      <div className="input-container">
        <input
          type="text"
          placeholder="Enter offer code"
          value={offerCode}
          onChange={handleInputChange}
        />
      </div>
      <CTAButton link={link} onClick={(e) => handleButtonClick(e)} {...props}>
        {children}
      </CTAButton>
    </StyledCTAButtonOfferCodeContainer>
  )
}

export default CTAButtonOfferCode

const StyledCTAButtonOfferCodeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.xxs};
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media (min-width: ${breakpoints.tablet}px) {
    flex-wrap: nowrap;
    gap: ${spacing.sm};
  }

  .input-container {
    input {
      padding: ${spacing.sm} ${spacing.md};
      ${typographyMixin(body.md)}
      box-sizing: border-box;
      min-width: 260px;
      height: ${spacing.xxl}; // Same height as CTAButton
      color: ${colors.semantic.text.secondary};
      border: ${borderWidth.xs} solid ${colors.semantic.border.secondary};
      border-radius: ${borderRadius.xs};
      background-color: ${colors.semantic.background.inverse};

      &::placeholder {
        color: ${colors.semantic.text.secondary};
        opacity: 0.7;
      }

      &:focus {
        outline: none;
        border-color: ${colors.semantic.border.accent};
      }
    }
  }

  // Ensure CTAButton maintains proper alignment
  .CTAButton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${spacing.xxl}; // Match input height
    min-width: 260px;
  }
`
